import { render, staticRenderFns } from "./ListagemLocaisEntrega.vue?vue&type=template&id=4bda09a0&"
import script from "./ListagemLocaisEntrega.vue?vue&type=script&lang=js&"
export * from "./ListagemLocaisEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports